/**
 * Created by neo on 21.01.2026
 * Settings Section - Contains app preferences like language and units
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { useTrans } from '../../Store/System/LocalizationStore';
import { LanguageSelector } from './LanguageSelector';
import { UnitSystemSelector } from './UnitSystemSelector';
import { Theme } from '../../Theme/Theme';

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SettingsCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const SettingsInfo = styled.div`
  margin-bottom: 16px;
`;

const SettingsTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: ${Theme.Colors.textColor};
  margin: 0 0 4px 0;
`;

const SettingsDescription = styled.p`
  font-size: 14px;
  color: ${Theme.Colors.charcoal};
  margin: 0;
`;

export const SettingsSection: React.FC = observer(() => {
  const { t } = useTrans();

  return (
    <SectionContent>
      <SettingsCard>
        <SettingsInfo>
          <SettingsTitle>{t('accountScreen.settings.language.title', { defaultValue: 'Language' })}</SettingsTitle>
          <SettingsDescription>
            {t('accountScreen.settings.language.description', { defaultValue: 'Change your preferred language' })}
          </SettingsDescription>
        </SettingsInfo>
        <LanguageSelector />
      </SettingsCard>

      <SettingsCard>
        <SettingsInfo>
          <SettingsTitle>{t('accountScreen.settings.units.title', { defaultValue: 'Units' })}</SettingsTitle>
          <SettingsDescription>
            {t('accountScreen.settings.units.description', { defaultValue: 'Switch between metric and imperial units' })}
          </SettingsDescription>
        </SettingsInfo>
        <UnitSystemSelector />
      </SettingsCard>
    </SectionContent>
  );
});
